import { useState, useEffect } from 'react'
import { useRouter } from "next/router";

function CmsPrivacyPolicy({ component, page_id = "" }) {
    const [data, setData] = useState(null)
    const [isLoading, setLoading] = useState(false)

    const {locale} = useRouter()

    useEffect(() => {
        var url = locale == 'en' ? 'https://www.iubenda.com/api/privacy-policy/74579925/only-legal' : 'https://www.iubenda.com/api/privacy-policy/37766545/only-legal'
        fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setData(data)
        setLoading(false)
      })
    }, [])


    if (isLoading) return <p>Loading...</p>

    return (
        <> 
            {data && !isLoading ?
                <div dangerouslySetInnerHTML={{ __html: data.content }} />
                : ''
            }
        </>
    );
}

export default CmsPrivacyPolicy;
